export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/identify-icon.29e65668.png";